module.exports = __webpack_public_path__ + "img/img_hub_motor.3747b626.png";